var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-5.07486e-07 7.01716C-4.96491e-07 6.76563 0.0960372 6.51414 0.287709 6.32238L6.32224 0.287903C6.70612 -0.0959679 7.3285 -0.0959679 7.71221 0.287903C8.09593 0.671619 8.09593 1.29388 7.71221 1.67778L2.37252 7.01716L7.71203 12.3566C8.09574 12.7404 8.09574 13.3626 7.71203 13.7463C7.32831 14.1304 6.70593 14.1304 6.32206 13.7463L0.287522 7.71194C0.0958194 7.52008 -5.18476e-07 7.26859 -5.07486e-07 7.01716Z",
    fill: "#B6B6B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.73b351df196c1ed385838895c5721c3b.svg";
export { ForwardRef as ReactComponent };